import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { AppShell } from './components/AppShell';
import { Loading } from './components/Loading';
import { DashboardPage } from './pages/DashboardPage';
import { InstallPage } from './pages/InstallPage';
import { LoginPage } from './pages/LoginPage';
import { LogPage } from './pages/LogPage';
import { ManagePage } from './pages/ManagePage';
import { RewardsPage } from './pages/RewardsPage';
import { SetupPage } from './pages/SetupPage';
import { SurveyPage } from './pages/SurveyPage';

export function App() {
  const { loading, status, me } = useAuth();
  if (loading || !status) return <Loading />;

  if (status.setupRequired) {
    return (
      <Routes>
        <Route path="/setup" element={<SetupPage />} />
        <Route path="*" element={<Navigate to="/setup" replace />} />
      </Routes>
    );
  }

  if (!me) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="log" element={<LogPage />} />
        <Route path="rewards" element={<RewardsPage />} />
        <Route path="manage" element={<ManagePage />} />
        <Route path="survey" element={<SurveyPage />} />
        <Route path="install" element={<InstallPage />} />
      </Route>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/setup" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
